import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api/payroll`;
export const getPayrollImports = () => axios.get(`${API}/imports`);
export const getPayrollImport = id => axios.get(`${API}/imports/${id}`);
export const getPayrollEmployees = () => axios.get(`${API}/employees`);
export const importPayroll = (data, onProgress) => axios.post(`${API}/imports`, data, { timeout: 180000, onUploadProgress: e => onProgress(e.total ? Math.round(e.loaded * 100 / e.total) : 0) });
export const reviewPayroll = (id, data) => axios.put(`${API}/imports/${id}/review`, data);
export const publishPayroll = (id, data) => axios.post(`${API}/imports/${id}/publish`, data, { timeout: 180000 });
export const retryPayroll = id => axios.post(`${API}/imports/${id}/retry`);
export const deletePayrollImport = id => axios.delete(`${API}/imports/${id}`);
export const previewPayroll = (id, pages) => axios.get(`${API}/imports/${id}/preview`, { params: { pages: pages.join(",") }, responseType: "blob" });
export const getPayslips = params => axios.get(`${API}/payslips`, { params });
export const payrollPeriod = p => p ? new Date(`${p}-01T12:00:00`).toLocaleDateString("fr-FR", { month: "long", year: "numeric" }) : "Mois non renseigné";
export const payrollError = err => typeof err.response?.data?.detail === "string" ? err.response.data.detail : "L’opération n’a pas abouti. Réessayez sans modifier votre sélection.";
export const parsePayrollPages = text => {
  const pages = [];
  for (const part of text.split(",")) {
    if (!/^\s*\d+(?:\s*-\s*\d+)?\s*$/.test(part)) throw new Error("Pages : utilisez 1,2 ou 1-3.");
    const [start, end = start] = part.trim().split("-").map(Number);
    if (start < 1 || end < start || end - start > 199) throw new Error("Intervalle de pages invalide.");
    for (let p = start; p <= end; p++) pages.push(p);
  }
  return pages;
};